import { useTranslation } from "react-i18next";
const SubscribeCard = () => {
  const {  t } = useTranslation();
  return (
    <div className="w-full">
      <div className="w-full sm:mx-0 mx-auto rounded-2xl bg-gradient-to-r from-[#DFF5FA] to-[#EAF9FD] p-2  flex flex-row sm:flex-col gap-6 items-center sm:justify-between justify-around ">
        
        {/* LEFT CONTENT */}
        <div className="flex flex-col justify-center gap-4 p-2 w-[60%] sm:w-full ">
          <img
            src="/images/socialIcon.png"
            alt="Subscribe"
            className="w-[75%] mx-auto hidden sm:block"
          />
          <h3 className="text-[#1A1A1A] text-start font-[Unbounded] text-2xl font-semibold leading-[40px]">
            {t("sweetMoments")}
          </h3>
          <p className="mt-2 w-full text-[#3E4147] font-[Inter] text-[16px] font-normal leading-[28px] text-left sm:text-center md:text-base">
            {t("joinOurCommunity")}
          </p>
          <div className=" sm:p-2 p-2 flex sm:items-center items-start mx-0  gap-4 bg-[#FFFFFF] rounded-full shadow-sm sm:mx-auto">
            <div className="relative flex-1">
              <img
                src="/images/emailIcon.svg"
                alt="emailIcon"
                className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5"
              />

              <input
                type="email"
                placeholder="Enter your email"
                className="w-full pl-10 pr-4 py-2 text-sm outline-none rounded-full border border-transparent focus:border-transparent focus:ring-0 font-[Inter]"
              />
            </div>      
            <button className="bg-[#771237] text-[#FFFFFF] text-[12px] leading-[24px] font-[Unbounded] font-medium px-4 py-2 rounded-full hover:opacity-90 transition">
              {t("subscribeNow")}
            </button>
          </div>
        </div>

          <img
            src="/images/socialIcon.png"
            alt="Subscribe"
            className="w-[20%] sm:hidden block"
          />
      </div>
    </div>
  );
};

export default SubscribeCard;
